import React from "react";
import { Typography } from "@mui/material";
import { softColors } from "../../constants/colors";
import { StyledDetailBox } from "./styles";
import { ObjectPopover } from "./ObjectPopover";
import { formatValue } from "./utils";
import translations from "./translations";

export const DetailRow = ({ label, value }) => {
  const isComplexObject =
    typeof value === "object" && value !== null && !(value instanceof Date);

  return (
    <StyledDetailBox>
      <Typography variant="subtitle2" sx={{ color: softColors.secondaryText }}>
        {translations[label] || label}
      </Typography>
      {isComplexObject ? (
        <ObjectPopover value={value} />
      ) : (
        <Typography
          variant="body1"
          sx={{
            color: softColors.text,
            fontWeight: 500,
            wordBreak: "break-word",
          }}
        >
          {formatValue(value)}
        </Typography>
      )}
    </StyledDetailBox>
  );
};